import { Grid, Radio } from "@material-ui/core"
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch } from "../../../redux/store";
import { Bar } from "react-chartjs-2";
import { SelectBox, Text, Button, SVG} from "sunrise-ui";
import { CHART_COLORS, customTooltip } from "../../../constants/reactChartConstants";
import MultiDropdown from "../../../utilities/MultiDropdown/MultiDropdown"
import SelectOptionMsg from "../../../utilities/SelectOptionMsg";
import { DATA_NOT_FOUND } from "../../../constants/globalConstants";
import { getAllProjectData, getProjectFinancialDetailsGraph, getOverallMonthlyFinancialDetails } from "../../../redux/reducers/projectReducers";
import moment from "moment";

const ClientBillingGraph = () => {
    const dispatch = useDispatch<AppDispatch>();
    const [isOverallBar, setIsOverallBar] = useState(true);
    const [multipleValue, setMultipleValue] = useState([]);
    const [projectName, setProjectName] = useState("");
    const [projectId, setProjectId] = useState("");
    const [clickSearch, setClickSearch] = useState(false);
    const [err, setErr] = useState(false);
    const [monthYearList, setmonthYearList] = useState([]);
    const [selectedMonthYear, setSelectedMonthYear] = useState<any[]>([]);

    const [workDoneMonthWiseData, setWorkDoneMonthWiseData] = useState<any[]>(
      []
    );
    const [billingDoneMonthWiseData, setBillingDoneMonthWiseData] = useState<
      any[]
    >([]);
    const [paymentReceivedMonthWiseData, setPaymentReceivedMonthWiseData] =
      useState<any[]>([]);
    const [monthWiseGraphLabels, setMonthWiseGraphLabels] = useState<any[]>([]);

    const [
      workDoneMonthAndProjectWiseData,
      setWorkDoneMonthAndProjectWiseData,
    ] = useState<any[]>([]);
    const [
      billingDoneMonthAndProjectWiseData,
      setBillingDoneMonthAndProjectWiseData,
    ] = useState<any[]>([]);
    const [
      paymentReceivedMonthAndProjectWiseData,
      setPaymentReceivedMonthAndProjectWiseData,
    ] = useState<any[]>([]);

    const [monthAndProjectWiseGraphLabels, setMonthAndProjectWiseGraphLabels] =
      useState<any[]>([]);

    const allProjectData = useSelector(
        (state: any) => state.PROJECT.allProjectData
      );
    const profileData = useSelector((state: any) => state.PROFILE.profileDetails);
    const pGraph = useSelector((state: any) => state.PROJECT.projectFinancialDataGraph);
    const oGraph = useSelector((state: any) => state.PROJECT.overallMonthlyFinancialData);
    // const monthYearList: any = [
    //     "Janaury '22", "Febraury '22", "March '22", "April '22", "May '22", "June '22", "July '22", "August '22",
    //      "September '22", "October '22", "November '22", "December '22"
    // ] 
    const changeReset = () => {  };

    useEffect(() => {
        if(profileData){
          dispatch(
            getAllProjectData({
              endPoint: `project/get-all-projects`,
            })
          );
        }
      }, [dispatch, profileData])
    
    const projectsData: [] = allProjectData && allProjectData?.map((item: any) => {
        return item?.projectName;
      }); 
    //   const monthList:any []  = multipleValue && multipleValue?.map((item: any) => {
    //     return item.split(' ')[0];
    // })
    // const dateList = monthList.toString().toLowerCase();

//-----Rs. to Crore conversion----
const getMonthYearArray = () => {
    const monthList = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    let monthYearData: any = [];
    let currentYear = new Date().getFullYear();
    let fromThisYear = currentYear - 1;
    let years = [];
    for (let i = currentYear; i >= fromThisYear; i--) {
      years.push(i);
    }
    years.forEach((year) => {
      let shortYear = year.toString().slice(2);
      monthList.forEach((month) => {
        monthYearData.push(`${month}'${shortYear}`);
      });
    });
    return monthYearData;
  };
  useEffect(() => {
    const myList = getMonthYearArray();
    setmonthYearList(myList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

 //-----Rs. to Crore conversion----
const numToCr = (value: any) => {
const val = parseFloat(value);
let valInCr;
if (val >= 1000000) {
  valInCr = +(val / 10000000).toFixed(2);
} else {
  valInCr = +(val / 10000000).toFixed(2);
}
return valInCr;
};
//-----------------convert datelist to timestamp string
const getMonthYear = (monthYear: any) => {
const year = new Date(monthYear).getFullYear().toString().slice(2);
const month = new Date(monthYear).toLocaleString("default", {
  month: "long",
});
return `${month}'${year}`;
};
useEffect(() => {
const mYList = multipleValue.map((monthYear: any) => {
  const date = moment(monthYear.slice(-2), "YY");
  const year = date.format("YYYY");
  const month = monthYear.split("'")[0];
  const dateStamp = new Date(`${month} 1, ${year} 00:00:00`);
  return dateStamp;
});
setSelectedMonthYear(mYList);
}, [multipleValue]);
 //-----------for overall data by month selection --------- 
 useEffect(() => {
    if(projectId === "" && clickSearch === true){
      dispatch(
        getOverallMonthlyFinancialDetails({
          endPoint: `project-finance/overall-monthly-finance-report?selectedMonthYear=${selectedMonthYear}`,
        })
      );
    }
  }, [clickSearch, dispatch, projectId, selectedMonthYear])
//--------for project and month selection------------
  useEffect(() => {
        if(projectId !== "" && clickSearch === true){
          dispatch(
            getProjectFinancialDetailsGraph({
              endPoint: `project-finance/monthly-finance-report?selectedMonthYear=${selectedMonthYear}&projectId=${projectId}`,
            })
          );
        }
      }, [clickSearch, dispatch, projectId, selectedMonthYear])
//-------------monthwise data-------------------------------------------------------------
useEffect(() => {
    if (oGraph?.length > 0) {
        const graphLabels = oGraph?.map((monthlyData: any) => {
            const monthYear = getMonthYear(monthlyData?.billDate);
            return monthYear;
        })
        setMonthWiseGraphLabels(graphLabels)
      const workDoneData = oGraph?.map((monthlyData: any) => {
        return (monthlyData.data?.[0]?.workDone!==null && monthlyData.data?.[0]?.workDone!==undefined && monthlyData.data?.[0]?.workDone!=="") ? numToCr(monthlyData.data?.[0]?.workDone) : 0
      });
      setWorkDoneMonthWiseData(workDoneData);
      const billingDoneData = oGraph?.map((monthlyData: any) => {
        return (monthlyData.data?.[0]?.billingDone!==null && monthlyData.data?.[0]?.billingDone!==undefined && monthlyData.data?.[0]?.billingDone!=="") ? numToCr(monthlyData.data?.[0]?.billingDone) : 0
      });
      setBillingDoneMonthWiseData(billingDoneData);
      const paymentReceivedData = oGraph?.map((monthlyData: any) => {
        return (monthlyData.data?.[0]?.paymentReceived!==null && monthlyData.data?.[0]?.paymentReceived!==undefined && monthlyData.data?.[0]?.paymentReceived!=="") ? numToCr(monthlyData.data?.[0]?.paymentReceived) : 0
      });
      setPaymentReceivedMonthWiseData(paymentReceivedData);
    }
  }, [oGraph]);
  //-------------monthwise and projectwise data-------------------------------------------------------------
useEffect(() => {
    if (pGraph?.length > 0) {
        const graphLabels = pGraph?.map((monthlyData: any) => {
            const monthYear = getMonthYear(monthlyData?.billDate);
            return monthYear;
        })
        setMonthAndProjectWiseGraphLabels(graphLabels)
      const workDoneData = pGraph?.map((monthlyData: any) => {
        return (monthlyData.data?.[0]?.workDone!==null && monthlyData.data?.[0]?.workDone!==undefined && monthlyData.data?.[0]?.workDone!=="") ? numToCr(monthlyData.data?.[0]?.workDone) : 0
      });
      setWorkDoneMonthAndProjectWiseData(workDoneData);
      const billingDoneData = pGraph?.map((monthlyData: any) => {
        return (monthlyData.data?.[0]?.billingDone!==null && monthlyData.data?.[0]?.billingDone!==undefined && monthlyData.data?.[0]?.billingDone!=="") ? numToCr(monthlyData.data?.[0]?.billingDone) : 0
      });
      setBillingDoneMonthAndProjectWiseData(billingDoneData);
      const paymentReceivedData = pGraph?.map((monthlyData: any) => {
        return (monthlyData.data?.[0]?.paymentReceived!==null && monthlyData.data?.[0]?.paymentReceived!==undefined && monthlyData.data?.[0]?.paymentReceived!=="") ? numToCr(monthlyData.data?.[0]?.paymentReceived) : 0
      });
      setPaymentReceivedMonthAndProjectWiseData(paymentReceivedData);
    }
  }, [pGraph]);
//--------barchart for overall(month)--------
const barChartData2: any = {
    labels: monthWiseGraphLabels,
    datasets: [
        {
            label: "Work Done",
            data: (workDoneMonthWiseData) ,
            backgroundColor: [CHART_COLORS.BLUE, CHART_COLORS.BLUE, CHART_COLORS.BLUE, CHART_COLORS.BLUE],
            hoverBackgroundColor: [CHART_COLORS.SELECTED_BLUE, CHART_COLORS.SELECTED_BLUE, CHART_COLORS.SELECTED_BLUE, CHART_COLORS.SELECTED_BLUE]
        },    
        {
            label: "Billing Done",
            data:(billingDoneMonthWiseData) ,
            backgroundColor: [CHART_COLORS.YELLOW, CHART_COLORS.YELLOW, CHART_COLORS.YELLOW, CHART_COLORS.YELLOW],
            hoverBackgroundColor: [CHART_COLORS.SELECTED_YELLOW, CHART_COLORS.SELECTED_YELLOW, CHART_COLORS.SELECTED_YELLOW, CHART_COLORS.SELECTED_YELLOW]
        },
        {
            label: "Payment Received",
            data: (paymentReceivedMonthWiseData) ,
            backgroundColor: [CHART_COLORS.GREEN,],
        },
    ],

};
 //-------bar chart data (project+month)------------
const barChartData1: any = {
    labels: monthAndProjectWiseGraphLabels,
    datasets: [
        {
            label: "Work Done",
            data: (workDoneMonthAndProjectWiseData) ,
            backgroundColor: [CHART_COLORS.BLUE, CHART_COLORS.BLUE, CHART_COLORS.BLUE, CHART_COLORS.BLUE],
            hoverBackgroundColor: [CHART_COLORS.SELECTED_BLUE, CHART_COLORS.SELECTED_BLUE, CHART_COLORS.SELECTED_BLUE, CHART_COLORS.SELECTED_BLUE]
        },    
        {
            label: "Billing Done",
            data:(billingDoneMonthAndProjectWiseData) ,
            backgroundColor: [CHART_COLORS.YELLOW, CHART_COLORS.YELLOW, CHART_COLORS.YELLOW, CHART_COLORS.YELLOW],
            hoverBackgroundColor: [CHART_COLORS.SELECTED_YELLOW, CHART_COLORS.SELECTED_YELLOW, CHART_COLORS.SELECTED_YELLOW, CHART_COLORS.SELECTED_YELLOW]
        },
        {
            label: "Payment Received",
            data: (paymentReceivedMonthAndProjectWiseData) ,
            backgroundColor: [CHART_COLORS.GREEN,],
        },
    ],

};

const billReportBarOptions: any = {
    plugins: {
        legend: {
            labels: {
                filter: function (item: any) {
                    // Logic to remove a particular legend item goes here
                    return !item.text.includes('REMOVE');
                }
            }
        },
        tooltip: customTooltip
    },
    maintainAspectRatio: false,
    scales: {
        y: { title: { display: true, text: 'Amount (Crores)', font: { weight: 'bold' } } },
        x: { title: { display: true, text: 'Month and Year', font: { weight: 'bold' } } },
    }
}

    return (
        <Grid spacing={2}>
         
            <Grid container xs={12} className="d-flex bg--white box--shadow p1 mt1 mr-1">
                <Grid item xs={12}>
                    <Grid className="d-flex">
                        <Text
                            type="normal"
                            fonts="normal"
                            fontSize={18}
                            className="mb1 mt0"
                        >
                            <span className="fw500">Client Billing Report</span>
                        </Text>
                    </Grid>

                    <Grid className="d-flex">
                        <Grid className="radio_box">
                            <Radio
                                checked={
                                    isOverallBar
                                }
                                onChange={(e) => {
                                    //handleStepChange(index, e);
                                    setIsOverallBar(true);
                                    setProjectId("");
                                    setMultipleValue([]);
                                    changeReset();
                                    setClickSearch(false);
                                    setErr(false);
                                    setBillingDoneMonthAndProjectWiseData([]);
                                    setPaymentReceivedMonthAndProjectWiseData([]);
                                    setBillingDoneMonthAndProjectWiseData([]);
                                }}
                                value="mandatory"
                                name="isMandatory"
                                inputProps={{ "aria-label": "Mandatory" }}
                                color="primary"
                            />
                            <label>Overall</label>
                            <Radio
                                checked={
                                    !isOverallBar
                                }
                                onChange={(e) => {
                                    setIsOverallBar(false);
                                    changeReset();
                                    setClickSearch(false);
                                    setErr(false);
                                    setMultipleValue([]);
                                    setBillingDoneMonthWiseData([]);
                                    setPaymentReceivedMonthWiseData([]);
                                    setWorkDoneMonthWiseData([]);
                                }}
                                value="optional"
                                name="isMandatory"
                                inputProps={{ "aria-label": "Optional" }}
                                color="primary"
                            />
                            <label>Project-Wise</label>
                        </Grid>
                    </Grid>

                    <Grid container xs={12} spacing={2}>
                        {!isOverallBar && <Grid item xs={3}>
                            <Text type="normal" fonts="normal" fontSize={18} className="mb0 mt1">
                                <span className="fw500">Select Project</span>
                            </Text>
                            <SelectBox
                                 data={projectsData ? projectsData : DATA_NOT_FOUND}
                                 placeHolder="Select Project"
                                 borderColor={"primary"}
                                 defaultValue={projectName}
                                 onChange={(e: any) => {
                                   setProjectName(e.target.value);
                                   const index = projectsData
                                     ?.map((item: any) => item)
                                     .indexOf(e.target.value);
                                   setProjectId(
                                     allProjectData && allProjectData[index]?._id
                                   );
                                   setBillingDoneMonthAndProjectWiseData([]);
                                    setPaymentReceivedMonthAndProjectWiseData([]);
                                    setBillingDoneMonthAndProjectWiseData([]);
                                 }}
                            />
                        </Grid>}
                        <Grid xs={3} item>
                            <Text type="normal" fonts="normal" fontSize={18} className="mb mt1">
                                <span className="fw500">Select Month and Year (max 6)</span>
                            </Text>

                            <MultiDropdown 
                                selectData={{
                                    data: (isOverallBar || projectId !== "") ? monthYearList : 
                                     "",
                                    name: "multiSelect",
                                    disabled: false,
                                    placeHolder: "Select Month and Year",
                                    borderColor: "primary",                                                                                     
                                    onChange: (e: any) => { 
                                        if(e.target.value.length < 7) {
                                        setMultipleValue(e.target.value);
                                         setErr(false);                                       
                                    } else
                                        setErr(true);
                                    } 
                                }}
                            />
                            {/* {err ? <Text type={err ? "danger" : "normal"} fonts="normal" fontSize={12} className={err ? "mb0 mt0 float-right" : "d-none"}>
                                Only takes max of 6 items
                            </Text> : "" } */}
                        </Grid>
                         <Grid item className="mt2 ml-1">
                        <Button
                            type="button"
                            size="medium"
                            isRounded={true}
                            category="primary"
                            onClick={() => {
                                if(multipleValue.length > 0 && multipleValue.length < 7) {
                                    setErr(false);
                                } else {
                                    setErr(true);
                                }
                                setClickSearch(true);
                                changeReset();
                            }}
                            className="submit_button mb1 mt3 mr-1 pl pr f14"
                        >
                            <SVG type={"searchIcon"} />
                            Search
                        </Button>
                    </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={11} style={{ height: 300 }} className="mt1" >
                   {(projectId !== "" && pGraph?.length > 0 && clickSearch === true && isOverallBar === false && multipleValue.length > 0 && !err)  ? 
                    <Bar data={barChartData1} options={billReportBarOptions} /> : 
                    (projectId === "" && oGraph?.length > 0 && clickSearch === true && isOverallBar === true && multipleValue.length > 0 && !err)  ? 
                    <Bar data={barChartData2} options={billReportBarOptions} /> : 
                      <Text
                          type="normal"
                          fonts="normal"
                          fontSize={18}
                          className="fw400 t-center"
                      >
                         <SelectOptionMsg text={`Select project to view Project information`} />
                      </Text>
        }
                </Grid>
            </Grid>
        </Grid >
    )
}

export default ClientBillingGraph;
